import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface FormikLabelProps {
  children: ReactNode;
}

const FormikLabel = ({ children }: FormikLabelProps) => {
  if (!children) return null;
  return (
    <Typography mb={1} variant="textSM" color="text.primary" fontWeight={600}>
      {children}
    </Typography>
  );
};

export default FormikLabel;
